import WOW from '../../js/pages/client-admin-app/wow.min';
import $ from "jquery";

let $offset = $(window).width() < 768 ? 70 : 120;

$(window).on('resize', () => {
	$offset = $(window).width() < 768 ? 70 : 120;
});

new WOW({
	offset: $offset
}).init();

document.addEventListener('DOMContentLoaded', () => {
	//console.log('n8n-app.js loaded');
	const arrows = document.querySelectorAll('.arrow-hero');
	const icons = document.querySelectorAll('.logo-container_icon');
	const bigCircle = document.querySelector('.own-branded-app-circle_1');

	// Intersection Observer для анімацій появи
	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				if (entry.target.classList.contains('arrow-hero')) {
					entry.target.classList.add('animate-arrow');
				} else {
					entry.target.classList.add('animate-icon');
				}
			}
		});
	}, { threshold: 0.3 });

	arrows.forEach(arrow => observer.observe(arrow));
	icons.forEach(icon => observer.observe(icon));

	// Паралакс великого кола
	window.addEventListener('scroll', () => {
		if (bigCircle) {
			bigCircle.style.transform = `translateY(${window.scrollY * 0.1}px)`;
		}
	});
});

document.addEventListener('DOMContentLoaded', () => {
	const circleLogos = document.querySelector('.circle-animated-logos');
	if (!circleLogos) return;

	const logos = circleLogos.querySelectorAll('.icon:not(.icon--main)');
	const mainIcon = circleLogos.querySelector('.icon--main');
	if (!mainIcon) return;

	const radius = 180;          // макс. радіус розльоту
	const rotationSpeed = 80;    // градусів додаткового обертання

	// Розрахунок мінімальної дистанції динамічно
	const mainRect = mainIcon.getBoundingClientRect();
	const mainSize = Math.max(mainRect.width, mainRect.height);
	const minDistance = mainSize * 0.75; // мін. відстань = ~75% розміру центру

	// Генеруємо базові кути для розльоту
	const positions = Array.from(logos).map((_, i, arr) => {
		const angle = (i / arr.length) * Math.PI * 2;
		return { baseAngle: angle };
	});

	function animateIcons() {
		const rect = circleLogos.getBoundingClientRect();
		const windowHeight = window.innerHeight;

		// Прогрес появи (0-1)
		const appearProgress = Math.min(1, Math.max(0, 1 - rect.top / (windowHeight * 0.8)));
		// Прогрес зникання (0-1)
		const disappearProgress = Math.min(1, Math.max(0, (rect.bottom - windowHeight * 0.2) / windowHeight));

		let progress = 0;

		if (appearProgress <= 0 && rect.top > 0) {
			progress = 0; // ще не доскролили
		} else if (appearProgress >= 1 && disappearProgress >= 1) {
			progress = 1; // блок повністю в зоні видимості
		} else if (appearProgress > 0 && appearProgress < 1) {
			progress = appearProgress; // фаза появи
		} else if (disappearProgress < 1) {
			progress = disappearProgress; // фаза зникання
		}

		const rotation = progress * (Math.PI / 180) * rotationSpeed;

		logos.forEach((logo, i) => {
			const { baseAngle } = positions[i];

			// Відстань від центру: між мінімальною та максимальною
			const distance = minDistance + (radius - minDistance) * progress;

			// Обертання навколо центру
			const x = Math.cos(baseAngle + rotation) * distance;
			const y = Math.sin(baseAngle + rotation) * distance;

			logo.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`;
		});
	}

	function onScroll() {
		requestAnimationFrame(animateIcons);
	}

	window.addEventListener('scroll', onScroll);
	window.addEventListener('resize', onScroll);

	animateIcons();
});
